import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import businessAuthSlice from "./businessAuthSlice";
import userManagementAuthSlice from "./userManagementAuthSlice";
import categorySlice from "./categorySlice";
import OTPSlice from "./OTPSlice";
import adminManagementSlice from "./adminManagementSlice";
import announcementSlice from "./announcementsSlice";
import usersSlice from "./usersSlice";
import locationsSlice from "./locationsSlice";
import { persistStore, persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import staticsSlice from "./staticsSlice";
import projectSlice from "./projectSlice";
import chatSlice from "./chatSlice";
import adSlice from "./adSlice";
import socketReducer from "./socketSlice";
import activityLogSlice from "./activityLogSlice";

const persistConfig = {
  key: "root",
  storage: sessionStorage,
};
const rootReducer = combineReducers({
  auth: authSlice,
  businessAuth: businessAuthSlice,
  userManagementAuth: userManagementAuthSlice,
  category: categorySlice,
  adminManage: adminManagementSlice,
  generateOTP: OTPSlice,
  announcement: announcementSlice,
  users: usersSlice,
  statics: staticsSlice,
  project: projectSlice,
  chat: chatSlice,
  ad: adSlice,
  socket: socketReducer,
  location: locationsSlice,
  activityLog: activityLogSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});
export const persistor = persistStore(store);
export default store;
